import styled from "@emotion/styled";

import { motion } from "framer-motion";

const TeamItemStyled = styled(motion.div)(() => ({
  gridColumn: "span 1",
  willChange: "transform",
  overflow: "hidden",
  position: "relative",
  minHeight: 500,
  borderRadius: 20,
}));

export default TeamItemStyled;
